import React, { useMemo } from 'react';

import { IconButton, styled, ListIcon, alpha } from '@gogame/components';
import { useScreenDispatch, useScreenState } from '@gogame/screens';

import {
  CHART_DEACTIVATE_BREAKDOWN_MODE,
  CHART_ACTIVATE_BREAKDOWN_MODE,
} from 'scenes/Trackers/Tracker/reducers';

import { useIsBreakdownMode, useChartState, useChartIndex } from '../hooks';
import {
  CHART_SETTINGS_OUTPUT,
  CHART_SETTINGS_OUTPUT_GROWTH,
} from './ChartSettingsAction';
import {
  DIMENSION_DAY,
  DIMENSION_MONTH,
  DIMENSION_WEEK,
} from 'scenes/Trackers/Tracker/constants';

//TODO: to make it with theme and to change the view switching of the icon
const ChartBreakdownHandleModeButton = styled(IconButton)`
  &:before,
  &:after {
    content: '';
    width: 2px;
    height: 26px;
    position: absolute;
    transform: rotate(-45deg);
  }
  &:after {
    top: 6px;
    left: 18px;
    background: ${({ theme }) => theme.palette.action.active}; //white;
  }
  &:hover:after {
    background: ${({ theme }) =>
      alpha(
        theme.palette.action.active,
        1 - theme.palette.action.hoverOpacity
      )};
  }
`;

function getDimension(state) {
  return [...state.drillPath].pop()?.type;
}

export const BreakdownModeAction = ({ disabled: disabledProp }) => {
  const isChartBreakdownMode = useIsBreakdownMode();
  const chartState = useChartState();
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const chartIndex = useChartIndex();

  const isChangeRate =
    chartState.settings[CHART_SETTINGS_OUTPUT] === CHART_SETTINGS_OUTPUT_GROWTH;

  const dimension = useMemo(() => {
    return getDimension(screenState);
  }, [screenState]);

  const notSupported = useMemo(() => {
    return [DIMENSION_DAY, DIMENSION_WEEK, DIMENSION_MONTH].includes(dimension);
  }, [dimension]);

  const handleActivateBreakdownMode = () =>
    dispatch({
      type: CHART_ACTIVATE_BREAKDOWN_MODE,
      payload: { index: chartIndex },
    });

  const handleDeactivateBreakdownMode = () =>
    dispatch({
      type: CHART_DEACTIVATE_BREAKDOWN_MODE,
      payload: { index: chartIndex },
    });

  let tooltipText = `Breakdown chart by the table's dimension`;

  if (isChartBreakdownMode) {
    tooltipText = 'Undo chart breakdown';
  }

  if (!isChartBreakdownMode && isChangeRate) {
    tooltipText =
      'To breakdown the chart change the "Output" setting to "Value"';
  }
  if (notSupported) {
    tooltipText = 'Not supported for the current dimension';
  }

  const disabled =
    (!isChartBreakdownMode && isChangeRate) || notSupported || disabledProp;
  return isChartBreakdownMode ? (
    <ChartBreakdownHandleModeButton
      icon={<ListIcon />}
      tooltip={tooltipText}
      onClick={handleDeactivateBreakdownMode}
      disabled={disabled}
    />
  ) : (
    <IconButton
      icon={<ListIcon />}
      tooltip={tooltipText}
      onClick={handleActivateBreakdownMode}
      disabled={disabled}
    />
  );
};
